import { z } from "zod";
import { V2ReviewExpertSchema, V2ReviewProjectSchema, V2ModeratorSchema, ProjectValueRangeSchema } from "./common";
import { AgencyTypeFieldsSchema, AgencyTypeSchema } from "../shared";

// Token Validation Schema
export const TokenValidationSchema = z.object({
    is_valid: z.boolean(),
    is_expired: z.boolean().optional(),
    client_exists: z.boolean().optional(),
    reason: z.enum(["not_found", "expired", "already_used", "cancelled"]).optional(),
    review_id: z.number().optional(),
    expert: V2ReviewExpertSchema.optional(),
    project: V2ReviewProjectSchema.nullable().optional(),
    message: z.string().nullable().optional(),
});

// User Search Schema
export const UserSearchExpertSchema = z.object({
    id: z.number(),
    slug: z.string(),
    type: z.enum(["freelancer", "agency"]),
    agency_type: AgencyTypeSchema.optional(),
    agency_type_fields: AgencyTypeFieldsSchema.optional(),
    name: z.string(),
});

export const UserSearchClientSchema = z.object({
    id: z.number(),
    company_name: z.string(),
});

export const UserSearchResultSchema = z.object({
    user_id: z.number().nullable(),
    user_name: z.string().nullable(),
    email: z.string().nullable(),
    profile_picture: z.string().nullable(),
    client: UserSearchClientSchema.nullable(),
});

export const UserSearchResponseSchema = z.array(UserSearchResultSchema);

export const ClientRegistrationUserSchema = z.object({
    id: z.number(),
    email: z.string(),
    first_name: z.string(),
    last_name: z.string(),
    user_type: z.literal("client"),
});

export const ClientRegistrationOrganizationSchema = z.object({
    id: z.number(),
    name: z.string(),
    org_type: z.literal("client"),
});

export const ClientRegistrationClientSchema = z.object({
    id: z.number(),
    company_name: z.string(),
    company_website: z.string().nullable(),
});

export const ClientRegistrationResponseSchema = z.object({
    user: ClientRegistrationUserSchema,
    organization: ClientRegistrationOrganizationSchema,
    client: ClientRegistrationClientSchema,
    token: z.string(),
    had_pending_invite: z.boolean(),
});

// Review Submission/Update Response Schemas
export const ReviewSubmissionResponseSchema = z.object({
    review_id: z.number(),
    overall_rating: z.number(),
    status: z.string(),
    replayed: z.boolean().optional(),
    expert: V2ReviewExpertSchema.optional(),
});

export const ReviewUpdateResponseSchema = z.object({
    review_id: z.number(),
    overall_rating: z.number(),
    updated_at: z.string(), // ISO8601 datetime string
    revision_count: z.number(),
});

export const AdminReviewUpdateResponseSchema = z.object({
    review_id: z.number(),
    overall_rating: z.number(),
    project_value_range_id: z.number().nullable(),
    hired_on_shopexperts_override: z.boolean().nullable().optional(),
    is_hired_on_shopexperts: z.boolean(),
    updated_at: z.string(), // ISO8601 datetime string
    revision_count: z.number(),
});

export const ReviewResponseUpdateResponseSchema = z.object({
    response_id: z.number(),
    response_text: z.string(),
    created_at: z.string(), // ISO8601 datetime string
    updated_at: z.string(), // ISO8601 datetime string
    is_new: z.boolean().optional(),
    revision_count: z.number().optional(),
});

export const ReviewModerationResponseSchema = z.object({
    review_id: z.number(),
    status: z.string(),
    moderated_by: V2ModeratorSchema,
    moderated_at: z.string(), // ISO8601 datetime string
    moderation_notes: z.string().nullable(),
});

export const SendReminderResponseSchema = z.object({
    review_request_id: z.number(),
    reminder_event_id: z.number(),
    sent_at: z.string().nullable(),
});

export const ProjectValueRangesResponseSchema = z.array(ProjectValueRangeSchema);
